import axios from "axios";

export type GetShopsParams = {
  keyword?: string;
  activeYn?: number;
  page?: number;
  rows?: number;
};

export type CreateShopPayload = {
  shop: {
    shopName: string;
    shopCode?: string;
    reprName?: string;
    taxId?: string;
    activeYn?: number;
    sortOrder?: number;
  },
  user: {
    loginId: string;
    password: string;
    nickname: string;
    userName: string;
    email?: string;
    phoneNumber?: string;
  }
};

export async function getShops(params: GetShopsParams) {
  const response = await axios.get('/api/admin/shops', {
    params,
  });

  return response.data;
}

export async function getShopData (shopId: number) {
  return axios.get(`/api/admin/shops/${shopId}`)
    .then(res => res.data)
}

export async function createShop(payload: CreateShopPayload) {
  const response = await axios.post('/api/admin/shops', payload);
  return response.data;
}

export async function autoGenerateRoomSlots (shopId, payload) {
  return axios.post(`/api/admin/shops/${shopId}/auto-generate-slots`, payload)
    .then(res => res.data)
}